import { render, staticRenderFns } from "./patient-flag-settings.vue?vue&type=template&id=267ad1c0&scoped=true"
import script from "./patient-flag-settings.vue?vue&type=script&lang=js"
export * from "./patient-flag-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267ad1c0",
  null
  
)

export default component.exports